import { ArrowUpRight, Mail, Phone } from 'lucide-react';
import { Reveal } from './Motion';
import { BrandMark } from './Brand';

export const QuickContacts = () => (
  <section className="page-width quick-contacts" id="recapiti" aria-label="Contatti rapidi" data-testid="quick-contacts-section">
    <Reveal className="quick-contact-item">
      <a href="tel:+393897949730" data-testid="phone-contact-link"><span className="contact-icon"><Phone size={21} strokeWidth={1.5} /></span><span className="contact-detail"><span className="eyebrow">PARLIAMONE A VOCE</span><span className="contact-value">389 794 9730</span></span><ArrowUpRight className="contact-arrow" size={23} strokeWidth={1.5} /></a>
    </Reveal>
    <Reveal className="quick-contact-item" delay={0.1}>
      <a href="mailto:e.fossat@composite-research.com" data-testid="email-contact-link"><span className="contact-icon"><Mail size={21} strokeWidth={1.5} /></span><span className="contact-detail"><span className="eyebrow">SCRIVIMI</span><span className="contact-value contact-email">e.fossat@composite-research.com</span></span><ArrowUpRight className="contact-arrow" size={23} strokeWidth={1.5} /></a>
    </Reveal>
  </section>
);

export const About = () => (
  <section className="about page-width" aria-label="Presentazione" data-testid="about-section">
    <Reveal className="about-label"><span className="eyebrow" data-testid="about-label"><span className="section-number">01 /</span> IL MIO APPROCCIO</span><BrandMark className="about-mark" /></Reveal>
    <Reveal className="about-copy" delay={0.1}>
      <p className="about-description" data-testid="about-description">Guido lo sviluppo di soluzioni e progetti orientati all’innovazione, con un approccio focalizzato su <span>ricerca, materiali e trasformazione industriale.</span></p>
      <p className="about-signature" data-testid="about-signature">Eugenio Fossat <span>CEO &amp; Co-Founder di Composite Research</span></p>
    </Reveal>
  </section>
);

export const BrandMarquee = () => (
  <div className="brand-marquee" aria-label="Re-newing Industry Through Materials" data-testid="brand-marquee">
    <div className="marquee-track" aria-hidden="true">{[0, 1, 2, 3].map(i => <span className="marquee-group" key={i}><span>Re-newing Industry</span><BrandMark /><span className="marquee-outline">Through Materials</span><span className="marquee-dot" /></span>)}</div>
  </div>
);